<template>
  <div>
    <div class="list-item">
      <TagTitleList
        :isOpt="isOpt"
        @clickTagTitleItem="clickTagTitleItem"
        :tagTitleList="tagTitleList"
      />
    </div>
    <div class="list-item">
      <el-button type="primary" size="small" @click="addTag" v-if="isOpt"
        >新增子选项</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="deleteItemTag"
        v-if="isDelete"
        >删除子选项</el-button
      >
    </div>
    <div class="list-item" :key="key" v-for="(item, key) in tags">
      <TagListComponent
        @handleTagClick="handleTagClick"
        :isOpt="isOpt"
        @blurTag="editTag"
        :isCheck="item.isCheck"
        @check="checkDeleteItem"
        @deleteTagClick="(e) => deleteTagClick(e)"
        @addItemTagClick="(id, name) => addItemTagClick(id, name)"
        :title="item.name"
        :tagParentId="item.id"
        :tagList="item.tags"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import OssUpload from "../../common/OssUpload";
import UploadFileUtils from "./UploadFileUtils";
import TagListComponent from "./component/TagListComponent.vue";
import TagTitleList from "./component/TagTitleList.vue";

export default {
  name: "Tag",
  props: {
    isOpt: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mySelectTags: [],
      tagTitleList: [],
      tags: [],
      currentTagId: 0,
      isDelete: false,
      isTitleActive: 0,
    };
  },
  components: {
    LoadingNoDialog,
    TagListComponent,
    TagTitleList,
  },
  mounted() {
    // this.getList()
    this.getTagList();
  },
  methods: {
    async getTagList() {
      let tags = await axios.get("/admin/tag/lists");

      this.tagTitleList = tags.data.map((item, key) =>
        key == 0 ? Object.assign(item, { isActive: true }) : item
      );
      if (this.isTitleActive) {
        this.tagLists = tags.data.map((item, key) =>
          item.id == this.isTitleActive
            ? Object.assign(item, { isActive: true })
            : Object.assign(item, { isActive: false })
        );
      }
      if (tags.data.length > 0) {
        //this.currentTagId = tags.data[0].id;
        this.tags = tags.data[0].tags;
        this.$store.state.tags=tags.data
        if (this.isTitleActive) {
          let activeTag = tags.data.find(
            (item) => item.id == this.isTitleActive
          );
          this.tags = activeTag.tags;
        }
        this.tags.map((item) => Object.assign(item, { isCheck: false }));
      }
    },
    async changFolder(e) {
      let files = e.target.files;

      console.info(files);
      let uploadFileUtils = new UploadFileUtils();
      let checkResult = uploadFileUtils.checkImgDir(files);
      console.info(checkResult);
      if (checkResult.flag === false) {
        this.$message.warning("上传的文件夹目录为一级或者三级，请检查");
        return;
      }
      // console.info(checkResult.files)
      checkResult.files = checkResult.files.sort(function (a, b) {
        return a.lastModified < b.lastModified ? 1 : -1;
      });
      // console.info(checkResult.files)

      let files2 = checkResult.files.filter((item) => item.length == 2);
      let files3 = checkResult.files.filter((item) => item.length == 3);
      let clearnRepeatFiles = Array.from(
        new Set(files3.map((item) => item.webkitRelativePath.split("/")[1]))
      );
      files3 = clearnRepeatFiles.map((item) =>
        files3.filter((each) => each.webkitRelativePath.indexOf(item) > -1)
      );
      //console.info(files3)
      files = uploadFileUtils.resetFilesSort(checkResult.files, files3);
      console.info(files);
      let results = [];
      for (let file of files) {
        // let otherResults=[]
        if (file.otherFiles) {
          for (let fileOther of file.otherFiles) {
            let suffix = uploadFileUtils.getSuffix(file.name);
            let r = await this.uploadImg(file, suffix, file.name);
            otherResults.push(r.objectKey);
          }
        } else {
          let suffix = uploadFileUtils.getSuffix(file.name);
          let r = await this.uploadImg(file, suffix, file.name);
          otherResults.push(r.objectKey);
        }
        //todo 上传到后台保存
        //results.push(otherResults)
      }
      console.info(results);
    },
    //清除上次状态
    clearnTag() {
      this.tagTitleList = this.tagTitleList.map((item) =>
        Object.assign(item, {
          tags: item.tags.map((each) =>
            Object.assign(each, {
              tags: each.tags.map((o) => Object.assign(o, { isActive: false })),
              aa: "bobocat",
            })
          ),
        })
      );
      this.mySelectTags = [];
    },

    async uploadImg(file, suffix, fileName) {
      let ossUpload = new OssUpload();
      let ossResult = await ossUpload.uploadFileForFileStream(
        file,
        1,
        suffix,
        fileName
      );
      return ossResult;
    },

    clickTagTitleItem(item) {
      let selectTags = this.tagTitleList.find((each) => each.id == item.id);
      this.currentTagId = selectTags.id;
      this.tags = selectTags.tags;
      this.isTitleActive = item.id;
    },
    async deleteTagClick(item) {
      let r = await axios.delete("/admin/tag/delete", {
        params: {
          id: item.id,
        },
      });
      if (r.code == 0) {
        this.getTagList();
        this.$message.success("删除成功");
      } else {
        this.$message.success("删除失败");
      }
    },
    //添加子标签
    async addItemTagClick(id, name) {
      let r = await axios.post("/admin/tag/add", {
        parentId: id,
        name: name,
      });
      this.getTagList();
      console.info(r);
    },
    //添加子标签
    addTag() {
      this.$prompt("请输入标签名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入正确的标签",
      })
        .then(async ({ value }) => {
          console.info(value);
          let r = await axios.post("/admin/tag/add", {
            parentId: this.currentTagId,
            name: value,
          });
          if (r.code == 0) {
            this.$message.success("新增成功");
            this.getTagList();
          } else {
            this.$message.error("添加失败");
          }
        })
        .catch(() => {});
    },
    //删除子标签
    async deleteItemTag() {
      this.$confirm(`确认删除选中列标签吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let r = await axios.delete("/admin/tag/delete-item", {
            params: {
              id: this.deleteItemId,
            },
          });
          if (r.code == 0) {
            this.$message.success("删除成功");
            this.getTagList();
            this.isDelete = false;
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    handleTagClick(obj) {
      console.info(obj)
      if (obj.tag.isActive) {
        this.mySelectTags.push(obj.tag.id);
      } else {
        this.mySelectTags = this.mySelectTags.filter(
          (item) => item !== obj.tag.id
        );
      }

      // this.tagTitleList
      let titleTagIds = [];
      for (let tagTitle of this.tagTitleList) {
        for (let tTag of tagTitle.tags) {
          for (let tag of tTag.tags) {
            if (this.mySelectTags.includes(tag.id)) {
              titleTagIds.push(tagTitle.id);
              titleTagIds.push(tTag.id)
            }
          }
        }
      }
      titleTagIds=Array.from(new Set(titleTagIds))
      this.$emit("handleTagClick", this.mySelectTags);
    },
    checkDeleteItem(id, flag) {
      this.deleteItemId = id;
      this.tags = this.tags.map((item) =>
        item.id == id
          ? Object.assign(item, { isCheck: !item.isCheck })
          : Object.assign(item, { isCheck: false })
      );

      let index = this.tags.findIndex((item) => item.isCheck == true);
      if (index > -1) {
        this.isDelete = true;
      } else {
        this.isDelete = false;
      }
    },
    async editTag(item) {
      let r = await axios.post("/admin/tag/edit", {
        id: item.id,
        name: item.name,
      });
      if (r.code !== 0) {
        this.$message.error("修改失败");
        return;
      }
      this.getTagList();
    },
  },
};
</script>
<style type="stylus" scope>
.list-item {
  padding: 5px 0px;
}
</style>




// WEBPACK FOOTER //
// src/main/admin/Tag.vue